import { NOTIFY } from "Lib/constants/app/actionTypes";

export const notify = data => ({
	type: NOTIFY,
	notify: data
});
